import { TYPE_RETIREMENT } from '../constants/type-retirement.constant';

export const homeDeliveryAddress = (typeRetirement, address) => {
	if (typeRetirement === TYPE_RETIREMENT.home) {
		return <p>{address}</p>;
	}
	return null;
};
